import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  active: boolean;
  /** Ile wektorów jest w indeksie (skala korpusu). */
  indexedCount?: number | null;
  label?: string;
  className?: string;
};

/** Widoczny feedback przy embed+Qdrant: pasek + czas + skala indeksu. */
export default function SemanticSearchProgress({
  active,
  indexedCount,
  label = "Szukam kontekstowo",
  className,
}: Props) {
  const [elapsedMs, setElapsedMs] = useState(0);

  useEffect(() => {
    if (!active) {
      setElapsedMs(0);
      return;
    }
    const started = Date.now();
    setElapsedMs(0);
    const id = window.setInterval(() => setElapsedMs(Date.now() - started), 200);
    return () => window.clearInterval(id);
  }, [active]);

  if (!active) return null;

  const seconds = (elapsedMs / 1000).toFixed(1);
  const scale =
    indexedCount != null && indexedCount > 0
      ? ` · korpus ~${indexedCount.toLocaleString("pl-PL")} wektorów`
      : "";

  return (
    <div
      className={cn(
        "w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2",
        className,
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex items-center justify-between gap-2 text-xs text-slate-600">
        <span className="inline-flex items-center gap-1.5 font-medium text-slate-800">
          <Loader2 className="h-3.5 w-3.5 animate-spin text-slate-500" />
          {label}
          {scale}
        </span>
        <span className="tabular-nums text-slate-500">{seconds}s</span>
      </div>
      <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-200">
        <div className="semantic-search-bar h-full w-1/3 rounded-full bg-slate-700" />
      </div>
      <p className="mt-1.5 text-[11px] leading-snug text-slate-500">
        Embedding zapytania + ranking w Qdrant. Przy dużym korpusie to może trwać kilka sekund.
      </p>
      <style>{`
        @keyframes semantic-search-slide {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(400%); }
        }
        .semantic-search-bar {
          animation: semantic-search-slide 1.2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
